import { AppointmentWizardState } from './appointment-wizard/appointment-wizard.state';
import { AuthenticationState } from './authentication/authentication.state';
import { InvoiceState } from './invoice/invoice.state';
import { PublicAppointmentWizardState } from './public-appointment-wizard/public-appointment-wizard.state';
import { QuotationState } from './quotation/quotation.state';
import { SidebarState } from './sidebar/sidebar.state';
import { WorkspaceState } from './workspace/workspace.state';

export const stateList = [
  AppointmentWizardState,
  AuthenticationState,
  SidebarState,
  InvoiceState,
  PublicAppointmentWizardState,
  WorkspaceState,
  QuotationState,
];
export const persistList = [
  AuthenticationState,
  SidebarState,
  InvoiceState,
  PublicAppointmentWizardState,
  WorkspaceState,
  QuotationState,
];
